import BaseResource                   from '@/lib/data/resource/BaseResource'
import { collect }                    from '@/lib/utils/array'
import NIIExtremeEventsResource      from '@/api/resources/risks/NIIExtremeEventsResource'
import NIIExtremeEventOptionResource from '@/api/resources/risks/NIIExtremeEventOptionResource'

export default class NIIExtremeEventsBaseResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.selectedPeriod = payload.selectedPeriod ?? 'risk12mAnalysisData'
    const p = payload[this.selectedPeriod] ?? {}

    const extremeEvents = p?.extremeEvents || payload
    const extremePeriods = p?.extremePeriods || payload

    this.NIIAnalysisId = payload.niiAnalysisId ?? null
    this.Events = collect(extremeEvents?.events || [], NIIExtremeEventsResource)
    this.CoreEvents = collect(extremeEvents?.coreEvents || [], NIIExtremeEventsResource)
    this.ExtraEvents = collect(extremeEvents?.extraEvents || [], NIIExtremeEventsResource)
    this.SelectedEvents = collect(extremeEvents?.selectedEvents || [], NIIExtremeEventOptionResource)
    this.SelectedPeriod = new NIIExtremeEventsResource(extremePeriods?.selectedPeriod || [])
    this.AllSupportedEvents = collect(extremeEvents?.allSupportedEvents || [], NIIExtremeEventOptionResource)
    this.EventsSelectionLocked = extremeEvents?.eventsSelectionLocked ?? false
    this.EventsSelectionSupported = extremeEvents?.eventsSelectionSupported ?? false
  }

  /* PROPERTIES */

  get Visible () {
    return this.EventsSelectionSupported === true
  }

  get Disabled () {
    return this.EventsSelectionLocked === true
  }

  /* METHODS */
}
